import fetch from 'node-fetch';

const makeRequest = async function(url) {
  const request = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });
  const response = await request.json();
  return response;
};

export { makeRequest };
